import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';
import {
  OwnerStatus,
  SchainLogicMode,
  SellersJsonStatus,
  type OwnerAdsTxtRecord,
  type OwnerDemandPartner,
  type OwnerDirectSchainRecord,
  type OwnerResellerSchainRecord,
} from './model';

const validHttpUrl = dashboardT('owners.validation.url');
const optionalHttpUrl = z.union([
  z.literal(''),
  z.url(validHttpUrl).refine((value) => /^https?:\/\//i.test(value), validHttpUrl),
]);
const optionalNonWhitespace = z.union([
  z.literal(''),
  z.string().trim().min(1, dashboardT('owners.validation.tcfVendorId')),
]);

export const ownerFormSchema = z.object({
  id: z.string(),
  name: z.string().trim().min(1, dashboardT('owners.validation.nameRequired')),
  status: z.enum(OwnerStatus),
  businessDomain: z.string(),
  sellersJsonUrl: optionalHttpUrl,
  sellersJsonStatus: z.enum(SellersJsonStatus),
  sellersJsonLastRefreshed: z.string(),
  sellersJsonCache: z.string(),
  sellersJsonFailReason: z.string(),
  tcfVendorId: optionalNonWhitespace,
  resellerBundleAllowlist: z.string(),
  billingEntity: z.string(),
  paymentCycle: z.string(),
  billingContactEmail: z.union([z.literal(''), z.email(dashboardT('owners.validation.email'))]),
  defaultSchainLogicMode: z.enum(SchainLogicMode),
  directSchainRecords: z.custom<OwnerDirectSchainRecord[]>(),
  resellerSchainRecords: z.custom<OwnerResellerSchainRecord[]>(),
  adsTxtRecords: z.custom<OwnerAdsTxtRecord[]>(),
  demandPartners: z.custom<OwnerDemandPartner[]>(),
  connectedDemandPartners: z.custom<OwnerDemandPartner[]>(),
});

export type OwnerFormValue = z.infer<typeof ownerFormSchema>;

export const emptyOwnerFormValue: OwnerFormValue = {
  id: '',
  name: '',
  status: OwnerStatus.Active,
  businessDomain: '',
  sellersJsonUrl: '',
  sellersJsonStatus: SellersJsonStatus.Unknown,
  sellersJsonLastRefreshed: '',
  sellersJsonCache: '',
  sellersJsonFailReason: '',
  tcfVendorId: '',
  resellerBundleAllowlist: '',
  billingEntity: '',
  paymentCycle: '',
  billingContactEmail: '',
  defaultSchainLogicMode: SchainLogicMode.ResellerPriority,
  directSchainRecords: [],
  resellerSchainRecords: [],
  adsTxtRecords: [],
  demandPartners: [],
  connectedDemandPartners: [],
};
